/**
 * @file
 *
 * Used to generate an anglers weigh in.  This will simply show the
 * anglers rank, fish count, and weight.
 *
 * @return Paragraph block with formatted rank, fishCount, and weight.
 */
import * as React from 'react';
import OrdinalRank from '../OrdinalRank/OrdinalRank';

// Types
import { IAnglerRankRedis, IAnglerTodayWeightRedis } from '../../types';

interface IProps {
  // Anglers rank object.
  rank: IAnglerRankRedis;
  // Number of the angler's fish count.
  fishCount: number;
  // Angler weight object.
  weight: IAnglerTodayWeightRedis;
}

const AnglerWeighIn: React.FunctionComponent<IProps> = ({
  rank,
  fishCount,
  weight,
}) => {
  return (
    <span className="leaderboard-list__rank-line" data-testid="angler-weigh-in">
      <OrdinalRank rank={rank} suffixMarkup=" Place, " />
      <span className="leaderboard-list__fish-count">Fish: {fishCount}, </span>
      <span className="leaderboard-list__fish-count">
        Weight: {weight['#']}
      </span>
    </span>
  );
};

export default AnglerWeighIn;
